import React from 'react'

const HeadingSection = ({heading, note, center}) => {
  return (
    <div className={center ? "whatsAppHeadingSection" :  "c-headingSection"}>
        <h2 className='c-heading'>{heading}</h2>
        <p className="c-note">{note}</p>
    </div>
  )
}

export default HeadingSection